module.exports = {
  BUILD_NUMBER: '2026-07-22',
  PROJECT_VERSION: "uhnEMR.0.165",
};
